import { gql } from '@apollo/client';
import { CARDMEDIAINTERFACE } from './commonInterfaces';

const TESTIMONIALS = gql`
  query TESTIMONIAL_REVIEWS {
    reviews(limit: 50, sort: "created_at:desc") {
      id
      review
      title
      traveller
      rating
      date
      source
      created_at
    }
  }
`;
const Our_Reviews = gql`
  query OUR_REVIEWS {
    reviews(limit: 60, sort: "created_at:desc") {
      id
      review
      title
      traveller
      rating
      date
      source
      created_at
    }
  }
`;
interface TESTIMONIAL_INTERFACE {
  reviews: [
    {
      id: string;
      title: string;
      review: string;
      traveller: string;
      rating: number;
      source: string;
      created_at: string;
    }
  ];
}

export { TESTIMONIALS, Our_Reviews };
export type { TESTIMONIAL_INTERFACE };
